import axios from 'axios';
import { FORGOT_PASSWORD_URL } from '../constants';

/**
 * Function for reset password email
 * @param  {Object} payload
 */
export const forgotPasswordApi = payload =>
  axios.post(FORGOT_PASSWORD_URL, { email: payload });
